module.exports = __webpack_public_path__ + "img/OBCINA ZIROVNICA.0bab91b0.png";